/**
 * Substitui variáveis no formato {{nome}} em um template.
 * Variáveis ausentes viram string vazia (e são reportadas em `missing`).
 */
export function renderTemplate(template, vars) {
    const missing = new Set();
    const text = template.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (_m, key) => {
        const v = vars[key];
        if (v === undefined || v === null || v === '') {
            missing.add(key);
            return '';
        }
        return String(v);
    });
    return { text, missing: [...missing] };
}
/** Lista as variáveis usadas em um template. */
export function extractTemplateVars(template) {
    const set = new Set();
    for (const m of template.matchAll(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g))
        set.add(m[1]);
    return [...set];
}
export function firstName(name) {
    if (!name)
        return '';
    return name.trim().split(/\s+/)[0] ?? '';
}
